import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import api from '../../lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/admin', { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        const res = await api.exchangeSession(sessionId);
        setUser(res.data);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin', { replace: true, state: { user: res.data } });
      } catch {
        navigate('/admin', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050508]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#7C3AED] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A1A1AA]">Authenticating...</p>
      </div>
    </div>
  );
}
